<template>
  <section class="report-trend" :aria-label="title">
    <h2>{{ title }}</h2>
    <p v-if="!rows.length">{{ $t('reportParity.empty') }}</p>
    <div v-for="(row, index) in rows" :key="index" class="trend-row">
      <span>{{ row.date || row.day }}</span>
      <div class="trend-track"><div :style="{ width: width(row) + '%' }" /></div>
      <strong>{{ Number(row[field] || 0).toLocaleString($i18n.locale) }}</strong>
    </div>
  </section>
</template>
<script>
export default {
  name: 'ReportTrend',
  props: { title: { type: String, required: true }, rows: { type: Array, default: () => [] }, field: { type: String, required: true } },
  methods: { width(row) { return (100 * Number(row[this.field] || 0)) / Math.max(1, ...this.rows.map((item) => Number(item[this.field] || 0))); } },
};
</script>
<style scoped>
.report-trend { border: 1px solid #ddd; padding: 16px; margin: 16px 0; }
h2 { font-size: 18px; line-height: 1.4; margin: 0 0 16px; font-weight: 500; }
.trend-row { display: grid; grid-template-columns: 100px minmax(0, 1fr) 90px; align-items: center; gap: 12px; margin: 8px 0; }
.trend-track { background: #eee; height: 10px; }
.trend-track > div { height: 100%; background: var(--q-primary); }
strong { text-align: right; }
</style>
